import { UserRole } from "../global";
import { sessionRoleMatchesAllowList } from "../global/role-session";
import type { IActiveUserSession } from "../ports/outputs/session";
import { RBAC_PERMISSIONS } from "./rbac-permission-codes";
import { sessionHasPermission } from "./session-permissions";

export function canManageTermsFromSession(
  session: IActiveUserSession | null | undefined,
): boolean {
  if (!session) {
    return false;
  }
  /** Super administrador: siempre puede acceder aunque el JWT sea anterior al permiso `terms.manage`. */
  if (sessionRoleMatchesAllowList(session.role, [UserRole.SuperAdministrator])) {
    return true;
  }
  return sessionHasPermission(session, RBAC_PERMISSIONS.TERMS_MANAGE);
}
